<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="page_4"></a><img alt="image" src="images/4.jpg"/></p>
<p class="caption">Six counties of east-central Mississippi constituted the region within which Meridian’s early development would occur. In 1840 these 40,000 square miles, covered with virgin forests interspersed with numerous rivers, streams, and some cultivated fields, were home to about twenty-five thousand pioneers. Meridian’s future location is denoted as Sowashee village in Lauderdale County. Countyseat towns are identified by circles. <em>J. Parker Lamb</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction1.vue?88199e52